(() => {
  const ACTIVE_CLASS = 'is-active';
  const OPEN_CLASS = 'is-open';

  /** @param {HTMLElement} root */
  const clearActive = (root) => {
    root.querySelectorAll('[data-stones-mega-tab]').forEach((tab) => {
      tab.classList.remove(ACTIVE_CLASS);
      tab.setAttribute('aria-selected', 'false');
    });
    root.querySelectorAll('[data-stones-mega-pane]').forEach((pane) => {
      pane.classList.remove(ACTIVE_CLASS);
    });
    root.classList.remove(OPEN_CLASS);
  };

  /**
   * @param {HTMLElement} root
   * @param {string} index
   */
  const setActive = (root, index) => {
    const activeTab = root.querySelector(`[data-stones-mega-tab="${index}"]`);
    const hasChildren = activeTab?.getAttribute('data-stones-mega-has-children') === 'true';

    if (!hasChildren) {
      // Leaf tab: only highlight it, don't open a pane
      root.querySelectorAll('[data-stones-mega-tab]').forEach((tab) => {
        const isActive = tab.getAttribute('data-stones-mega-tab') === index;
        tab.classList.toggle(ACTIVE_CLASS, isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      root.querySelectorAll('[data-stones-mega-pane]').forEach((pane) => {
        pane.classList.remove(ACTIVE_CLASS);
      });
      root.classList.remove(OPEN_CLASS);
      return;
    }

    root.classList.add(OPEN_CLASS);

    root.querySelectorAll('[data-stones-mega-tab]').forEach((tab) => {
      const isActive = tab.getAttribute('data-stones-mega-tab') === index;
      tab.classList.toggle(ACTIVE_CLASS, isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    root.querySelectorAll('[data-stones-mega-pane]').forEach((pane) => {
      const isActive = pane.getAttribute('data-stones-mega-pane') === index;
      if (isActive) {
        pane.classList.remove(ACTIVE_CLASS);
        void pane.getBoundingClientRect();
        pane.classList.add(ACTIVE_CLASS);
      } else {
        pane.classList.remove(ACTIVE_CLASS);
      }
    });
  };

  /** @param {HTMLElement} root */
  const activateFirst = (root) => {
    const first = root.querySelector('[data-stones-mega-tab][data-stones-mega-has-children="true"]');
    if (first instanceof HTMLElement) {
      const idx = first.getAttribute('data-stones-mega-tab');
      if (idx) setActive(root, idx);
    }
  };

  /** @param {Element} root */
  const init = (root) => {
    if (!(root instanceof HTMLElement)) return;
    if (root.dataset.stonesMegaInitialized === 'true') return;
    root.dataset.stonesMegaInitialized = 'true';

    // Activate first category immediately so content is ready when menu opens
    activateFirst(root);

    root.addEventListener('mouseover', (event) => {
      const target = event.target instanceof Element
        ? event.target.closest('[data-stones-mega-tab]')
        : null;
      if (target instanceof HTMLElement) {
        const idx = target.getAttribute('data-stones-mega-tab');
        if (idx) setActive(root, idx);
      }
    });

    root.addEventListener('focusin', (event) => {
      const target = event.target instanceof Element
        ? event.target.closest('[data-stones-mega-tab]')
        : null;
      if (target instanceof HTMLElement) {
        const idx = target.getAttribute('data-stones-mega-tab');
        if (idx) setActive(root, idx);
      }
    });

    // No mouseleave on .stones-mega — menu closing is handled by header-menu.js
    // and clearing active on mouseleave caused content to vanish when hovering
    // the bottom padding of the submenu container.
  };

  const boot = () => {
    document.querySelectorAll('[data-stones-mega]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
